import React from 'react';
import { KTSVG } from '../../../../../../../_start/helpers';
import { AttachSvgModal } from '../../../../components/AttachSvgModal';
import {
  HeadingsAndDescriptionsItem,
  HomeThreeIconsHeadingsAndDescriptionsElement,
} from './HomeThreeIconsHeadingsAndDescriptionsElement';

interface Props {
  idx: number;
  data: HomeThreeIconsHeadingsAndDescriptionsElement;
  item: HeadingsAndDescriptionsItem;
  updateData: (to: Partial<HeadingsAndDescriptionsItem>, idx: number) => void;
}

export const HomeThreeIconsHeadingsAndDescriptionsIcon: React.FC<Props> = ({
  idx,
  data,
  item,
  updateData,
}) => {
  return (
    <>
      <AttachSvgModal
        modalId={`home-three-icons-headings-and-descriptions-${idx}-${data.id}`}
        updateCallback={(icon_url) => updateData({ icon_url }, idx)}
      />
      <div style={{ width: '3rem', height: '3rem' }}>
        <div className="overlay">
          <div className="overlay-layer bg-dark bg-opacity-10">
            <label
              className="px-1 btn btn-sm btn-icon btn-color-primary btn-light-primary"
              data-bs-toggle="modal"
              data-bs-target={`#home-three-icons-headings-and-descriptions-${idx}-${data.id}`}
            >
              <KTSVG
                path="/media/icons/duotone/General/Edit.svg"
                className="svg-icon-1"
              />
            </label>
          </div>
          <div>
            {item.icon_url ? (
              <img className="icon" src={item.icon_url} alt="Uploaded" />
            ) : (
              <KTSVG path={item.icon ?? ''} svgClassName="icon" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
